export const LIST = 'list';
export const MAP = 'map';
export const TRACK = 'track';
export const TRAIL = 'trail';
